import { gql } from '@apollo/client';

export const GET_PEOPLEPROFILE_INSTITUTION = gql`
  query GetPeopleProfileInstitution($id: ID) {
    institution: getPeopleProfileInstitution(id: $id) {
      id
      name
      type {
        id
        name
      }
    }
  }
`;
